import { useState, useEffect } from 'react';

/**
 * Matches the CSS mobile breakpoint (max-width: 767px).
 *
 * Components that lay themselves out with inline style objects cannot use
 * media queries, so they read this instead and pick a style object.
 */
export default function useIsMobile(query = '(max-width: 767px)') {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);

    // Safari < 14 only supports the deprecated addListener signature
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return isMobile;
}
